<template>
    <c-model
        width="80%"
        @confirm="examineSubmit"
        ref="detailForm"
        title="报考信息"
    >
        <c-register-form
            disabled
            :enrolInfo="enrolInfo"
            :attachments="attachments"
            :extraFields="extraFields"
            class="signUpForm"
            ref="signUpForm"
        ></c-register-form>
        <el-collapse
            accordion
            v-model="activeNames"
            v-if="enrolHistory.length != 0"
            class="action-group"
        >
            <el-collapse-item class="examine_title" name="btnGroup">
                <template slot="title"
                    >审查记录:</template
                >
                <template v-for="(item, index) in enrolHistory">
                    <div :key="index" class="enrol_history">
                        <span>{{ item.createTime }}</span>
                        <span>{{ item.userFullName }}</span>
                        <span :class="item.status == 1 ? 'success' : 'error'">{{
                            item.status | SignUpFilter
                        }}</span>
                        <span v-if="item.remark"
                            >({{ item.remark }})</span
                        >
                    </div>
                </template>
            </el-collapse-item>
        </el-collapse>
        <el-form
            ref="examineForm"
            v-if="getUserRole != 1"
            class="examine-form"
            :model="examineInfo"
        >
            <el-form-item
                label="审查结果:"
                prop="status"
                required
                hiddenErrorText
            >
                <el-select v-model="examineInfo.status" @change="$_onValidateRemark">
                    <el-option label="审查通过" :value="1"></el-option>
                    <el-option label="审查不通过" :value="2"></el-option>
                    <el-option label="待定" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="备注:"
                prop="remark"
                :required="examineInfo.status == 2 || examineInfo.status == 3"
            >
                <el-input
                    type="textarea"
                    v-model="examineInfo.remark"
                ></el-input>
            </el-form-item>
        </el-form>
        <template slot="otherBtn">
            <el-tooltip
                effect="dark"
                content="如无法打印,请使用谷歌浏览器打印"
                placement="top"
            >
                <a @click="printSignUpInfo" class="btn btn-save">打印报名表</a>
            </el-tooltip>
        </template>

        <div id="print_canvas"></div>
    </c-model>
</template>

<script>
import { userRes } from '@/api';
import { mapGetters, mapActions } from 'vuex';
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        extraFields: {
            type: Array,
            default: () => {
                return [];
            },
        },
        print: {
            type: Boolean,
            default: false,
        },
        enrolInfo: Object,
        attachments: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            examineInfo: {
                status: '',
                remark: '',
                enrolId: null,
            },
            //   enrolInfo: {},
            enrolHistory: [],
            activeNames: [],
            status: '',
        };
    },
    computed: {
        ...mapGetters(['getUserRole']),
    },
    methods: {
        ...mapActions(['getUserInfo']),
        open(data = {}) {
            // 判断用户状态
            this.examineInfo.remark = '';
            if (this.getUserRole && this.getUserRole != 1) {
                this.examineInfo.enrolId = data.id;
                this.status = data.status;
                this.getEnrolHistory();
            }

            this.$refs.detailForm.open();
        },
        getEnrolHistory(data) {
            // 查询审批记录
            const { enrolId } = this.examineInfo;
            userRes.queryEnrolVerifyList({ enrolId }).then((res) => {
                this.enrolHistory = res;
            });
        },
        examineSubmit() {
            if (this.$refs.examineForm) {
                this.$refs.examineForm.validate((valid) => {
                    if (valid) {
                        const {
                            examineInfo: { status, remark, enrolId },
                        } = this;
                        userRes
                            .approvalEnrolVerify({ status, remark, enrolId })
                            .then((res) => {
                                this.$emit('confirmcallback');
                                this.$refs.detailForm.close();
                            });
                    }
                });
            } else {
                this.$refs.detailForm.close();
            }
        },
        // 打印报名表
        printSignUpInfo() {
            this.$refs.signUpForm.print();
        },
        $_onValidateRemark(){
            this.$refs.examineForm.clearValidate('remark');
        }
    },
};
</script>

<style lang="scss">
.examine-form {
    padding-top: 20px;
}
.examine_title .el-collapse-item__header {
    font-weight: bold;
    color: #666;
}
.enrol_history {
    margin-bottom: 5px;
    position: relative;
    // border-bottom: 1px solid #eee;
    color: #666;
    padding: 5px;
    padding-left: 22px;
    & .success {
        color: $main_color;
    }
    & .error {
        color: red;
    }
    &:before {
        position: absolute;
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background-color: $main_color;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
    }
}
</style>
